import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { SeekElementInBranch } from '@common/utils/DOM';
import { RouterLink } from '@node_modules/vue-router';
import { computed, getCurrentInstance, onMounted, ref, useSlots } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseListItem',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: null,
    href: null,
    target: null,
    color: null,
    elementAlignment: {
      default: 'center'
    },
    density: null,
    overflowHidden: {
      type: Boolean,
      default: true
    },
    icon: null,
    iconColor: null
  },
  emits: ["click", "keyup", "keydown", "focus"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const slots = useSlots();
    const hasPrependContent = computed(() => !!slots.prepend);
    const hasAppendContent = computed(() => !!slots.append);
    const hasActionsContent = computed(() => !!slots.actions);
    const instance = getCurrentInstance();
    const hasClickListener = computed(() => !!instance?.proxy.$listeners.click);
    const htmlEl = computed(() => {
      return props.href ? 'a' : hasClickListener.value ? 'button' : 'div';
    });
    const isRouterLink = computed(() => !!props.to);
    const isButton = computed(() => htmlEl.value === 'button');
    const isAnchor = computed(() => htmlEl.value === 'a');
    const rootEl = ref();
    const on = {
      click(e) {
        emit('click', e);
      },
      keyup(e) {
        emit('keyup', e);
      },
      keydown(e) {
        emit('keydown', e);
      },
      focus(e) {
        emit('focus', e);
      }
    };
    const isBSMenuItem = ref(false);
    const attrs = computed(() => {
      const result = {};
      // CLASES
      const classes = ['d-flex list-group-item'];
      if (hasActionsContent.value) {
        classes.push('pl-3 pr-1');
      } else classes.push('px-3');
      if (props.density == "compact") classes.push("py-1");
      if (props.density == "comfortable") classes.push("py-2");
      if (props.elementAlignment) classes.push(`align-items-${props.elementAlignment}`);
      if (props.active) classes.push('active');
      if (props.disabled) classes.push('disabled');
      if (props.to || props.href || hasClickListener.value) classes.push('list-group-item-action');
      if (props.color) classes.push(`list-group-item-${props.color}`);
      if (isButton.value || isAnchor.value || isRouterLink.value) classes.push('pointer');
      if (isBSMenuItem.value) classes.push('dropdown-item');
      result.class = classes.join(' ');
      if (props.href) result.href = props.href;
      // LINK
      if (props.href) {
        result.href = props.href;
        if (props.target) result.target = `_${props.target}`;
      }
      // MISC
      if (isButton.value) result.type = 'button';
      return result;
    });
    onMounted(init);
    function init() {
      if (!rootEl.value) {
        setTimeout(init, 100);
        return;
      }
      const target = rootEl.value.$el ?? rootEl.value;
      isBSMenuItem.value = !!SeekElementInBranch(target, 'hasClass', 'dropdown-menu');
    }
    return {
      __sfc: true,
      props,
      emit,
      slots,
      hasPrependContent,
      hasAppendContent,
      hasActionsContent,
      instance,
      hasClickListener,
      htmlEl,
      isRouterLink,
      isButton,
      isAnchor,
      rootEl,
      on,
      isBSMenuItem,
      attrs,
      init,
      RouterLink
    };
  }
});